
export interface AuthorInfo {
  name: string;
  slug: string;
  title: string;
  bio: string;
  avatar: string;
  credentials: string[];
  social: { twitter?: string; linkedin?: string };
}

export const authors: Record<string, AuthorInfo> = {
  'Sarah Mitchell': {
    name: 'Sarah Mitchell',
    slug: 'sarah-mitchell',
    title: 'Senior Tax Strategist',
    bio: 'Sarah is a CPA with 12 years of experience in personal tax planning for high-income professionals in New York City. She specializes in multi-state taxation and freelancer tax optimization.',
    avatar: 'https://public.readdy.ai/ai/img_res/611756384a1328b91e55230a74b8a9ca.jpg',
    credentials: ['CPA', 'CFP'],
    social: { twitter: '#', linkedin: '#' },
  },
  'David Chen': {
    name: 'David Chen',
    slug: 'david-chen',
    title: 'Equity Compensation Specialist',
    bio: 'David advises Bay Area tech workers on RSU taxation, stock option strategies, and California tax planning. Former tax analyst at a Big Four accounting firm with expertise in equity compensation.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20Asian%20American%20man%20in%20his%20early%2030s%20wearing%20glasses%20and%20a%20light%20blue%20shirt%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait&width=200&height=200&seq=author-david&orientation=squarish',
    credentials: ['CPA', 'MBA'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Marcus Rivera': {
    name: 'Marcus Rivera',
    slug: 'marcus-rivera',
    title: 'Relocation Tax Advisor',
    bio: 'Marcus helps professionals navigate the tax implications of relocating between states. Based in Austin, he has guided hundreds of workers through moves from high-tax to low-tax states.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Hispanic%20man%20in%20his%20late%2030s%20with%20short%20dark%20hair%20wearing%20a%20charcoal%20suit%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait&width=200&height=200&seq=author-marcus&orientation=squarish',
    credentials: ['EA', 'Tax Advisor'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Jennifer Walsh': {
    name: 'Jennifer Walsh',
    slug: 'jennifer-walsh',
    title: 'Midwest Tax Specialist',
    bio: 'Jennifer is an enrolled agent specializing in Illinois and Midwest state taxation. She writes about flat tax strategies, property tax optimization, and retirement planning for Chicago-area professionals.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20in%20her%20early%2040s%20with%20blonde%20hair%20wearing%20a%20white%20blouse%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait%20photography&width=200&height=200&seq=author-jennifer&orientation=squarish',
    credentials: ['EA'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Carlos Mendez': {
    name: 'Carlos Mendez',
    slug: 'carlos-mendez',
    title: 'International Tax Consultant',
    bio: 'Carlos specializes in Florida residency establishment and international tax planning for professionals relocating to Miami. He advises clients on cross-border taxation and Latin American business structures.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Latino%20man%20in%20his%20mid%2030s%20with%20dark%20hair%20wearing%20a%20tan%20blazer%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait%20photography&width=200&height=200&seq=author-carlos&orientation=squarish',
    credentials: ['CPA', 'International Tax'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Emily Nakamura': {
    name: 'Emily Nakamura',
    slug: 'emily-nakamura',
    title: 'Pacific Northwest Tax Analyst',
    bio: 'Emily covers Washington State tax policy, capital gains taxation, and B&O tax compliance for Seattle-area professionals. She previously worked at the Washington Department of Revenue.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Japanese%20American%20woman%20in%20her%20late%2020s%20with%20long%20black%20hair%20wearing%20a%20sage%20green%20top%20warm%20studio%20lighting%20neutral%20background%20portrait&width=200&height=200&seq=author-emily&orientation=squarish',
    credentials: ['CPA'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Dr. Robert Keane': {
    name: 'Dr. Robert Keane',
    slug: 'robert-keane',
    title: 'Retirement Tax Planning Expert',
    bio: 'Dr. Keane holds a PhD in Financial Planning and specializes in retirement income tax optimization. He advises pre-retirees on Roth conversion strategies, pension taxation, and Medicare planning.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20man%20in%20his%2050s%20with%20gray%20hair%20wearing%20a%20dark%20suit%20and%20tie%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait&width=200&height=200&seq=author-robert&orientation=squarish',
    credentials: ['PhD', 'CFP', 'CPA'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Jake Morrison': {
    name: 'Jake Morrison',
    slug: 'jake-morrison',
    title: 'Colorado Tax & Lifestyle Writer',
    bio: 'Jake covers Colorado tax policy, TABOR refunds, and the financial side of mountain-state living. A Denver native, he helps professionals understand the unique tax advantages of living in Colorado.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20in%20his%20early%2030s%20with%20light%20brown%20hair%20and%20a%20beard%20wearing%20a%20flannel%20shirt%20warm%20studio%20lighting%20neutral%20background%20casual%20portrait&width=200&height=200&seq=author-jake&orientation=squarish',
    credentials: ['EA'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Tanya Brooks': {
    name: 'Tanya Brooks',
    slug: 'tanya-brooks',
    title: 'Southeast Tax Specialist',
    bio: 'Tanya specializes in Georgia and Southeast state taxation, with expertise in film industry tax credits and retirement income planning. She advises Atlanta-area professionals on maximizing take-home pay.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20an%20African%20American%20woman%20in%20her%20mid%2030s%20with%20natural%20hair%20wearing%20a%20coral%20blazer%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait&width=200&height=200&seq=author-tanya&orientation=squarish',
    credentials: ['CPA', 'CFP'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Lisa Hernandez': {
    name: 'Lisa Hernandez',
    slug: 'lisa-hernandez',
    title: 'Arizona Tax & Retirement Advisor',
    // Fixed escaping for the apostrophe
    bio: "Lisa covers Arizona's flat tax system and senior property tax relief programs.",
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Latina%20woman%20in%20her%20late%2030s%20with%20dark%20wavy%20hair%20wearing%20a%20cream%20colored%20blouse%20warm%20studio%20lighting%20neutral%20background%20portrait&width=200&height=200&seq=author-lisa&orientation=squarish',
    credentials: ['EA', 'Retirement Specialist'],
    social: { twitter: '#', linkedin: '#' },
  },
  'James Whitfield': {
    name: 'James Whitfield',
    slug: 'james-whitfield',
    title: 'UK Tax & Pension Specialist',
    bio: 'James is a chartered accountant specializing in UK income tax, National Insurance, and pension planning for London professionals. He previously worked at HMRC and advises on Self-Assessment and IR35 compliance.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20British%20man%20in%20his%20early%2040s%20with%20short%20brown%20hair%20wearing%20a%20navy%20suit%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait&width=200&height=200&seq=author-james&orientation=squarish',
    credentials: ['ACA', 'CTA'],
    social: { twitter: '#', linkedin: '#' },
  },
  'Michael Torres': {
    name: 'Michael Torres',
    slug: 'michael-torres',
    title: 'Philadelphia Tax Specialist',
    // Fixed escaping for the apostrophe
    bio: "Michael specializes in Pennsylvania and Philadelphia wage tax planning. He helps Philly-area workers navigate the city's unique wage tax system and maximize remote work tax refunds.",
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20in%20his%20mid%2030s%20with%20dark%20hair%20wearing%20a%20gray%20suit%20warm%20studio%20lighting%20neutral%20background%20corporate%20portrait%20photography&width=200&height=200&seq=author-michael&orientation=squarish',
    credentials: ['CPA'],
    social: { twitter: '#', linkedin: '#' },
  },
};

export const getAuthor = (name: string): AuthorInfo | null => {
  // Defensive check: ensure the provided name is a string and exists in the map
  if (typeof name !== 'string') {
    console.warn('getAuthor called with a non‑string argument:', name);
    return null;
  }
  return authors[name] ?? null;
};
